import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface ExchangeRatesProps {
  baseCurrency: string;
}

const ExchangeRates: React.FC<ExchangeRatesProps> = ({ baseCurrency }) => {
  const [exchangeRates, setExchangeRates] = useState<{ [key: string]: number }>({});
  const [loading, setLoading] = useState(true);

  // Define a set of currencies to display
  const displayCurrencies = ['USD', 'EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'CHF', "SEK", 'CNY', 'SEK', 'NZD'];

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const response = await axios.get<{ rates: { [key: string]: number } }>(`https://api.exchangerate-api.com/v4/latest/${baseCurrency}`);
        setExchangeRates(response.data.rates);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching exchange rates:', error);
        setLoading(false);
      }
    };

    fetchExchangeRates();
  }, [baseCurrency]);

  if (loading) {
    return <div>Loading exchange rates...</div>;
  }

  // Filter the exchange rates to only include the displayCurrencies
  const filteredRates = Object.entries(exchangeRates).filter(([currency]) =>
    displayCurrencies.includes(currency)
  );

  return (
    <div className='container d-flex justify-content-center pt-3 pb-0'>
    <div className="exchange-rates">
      <h3>All Prices in € (euros) Exchange Rates (Base: {baseCurrency})</h3>
      <ul>
        {filteredRates.map(([currency, rate]) => (
          <li key={currency}>
            {currency}: {rate.toFixed(2)}
          </li>
        ))}
      </ul>
    </div>
    </div>
  );
};

export default ExchangeRates;